/**
 * Permission codes of the supplementary budget request screens (FSD 2.2.5 FIN-F06 V07).
 *
 * `read` lists and opens requests; `request` raises one. Approval is banded by value and
 * decided in the Approvals Inbox by someone other than the requester.
 */
export const BUDGET_SUPPLEMENTARY_PERMISSIONS = {
  read: 'budget.supplementary.read',
  request: 'budget.supplementary.request',
} as const
